import { css } from '@emotion/react';
import { Button, color, spacing, typography } from '@uniquegood/realworld-studio-design';

import ConnectCard from '../components/ConnectCard';

interface ErrorStateProps {
  message: string;
  /** "다시 시도" 버튼 클릭 시. 비워두면 버튼을 숨긴다. */
  onRetry?: () => void;
}

/**
 * error state — exchange API 실패 (만료 외).
 *
 * 만료(expired)는 별도 상태로 분리됨. 여기서는 일반 에러만 처리한다.
 */
export default function ErrorState({ message, onRetry }: ErrorStateProps) {
  return (
    <ConnectCard eyebrow="Realworld School" title="스쿨 계정 연결">
      <div css={styles.body} data-testid="connect-state-error">
        <div css={styles.iconWrap} aria-hidden="true">
          <span css={styles.iconCircle}>✕</span>
        </div>
        <p css={styles.text}>{message}</p>

        {onRetry ? (
          <Button type="outlineBasic" size="medium" onClick={onRetry} cssStyle={styles.button}>
            다시 시도
          </Button>
        ) : null}
      </div>
    </ConnectCard>
  );
}

const styles = {
  body: css`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${spacing.common.medium};
    text-align: center;
  `,
  iconWrap: css`
    display: flex;
    align-items: center;
    justify-content: center;
  `,
  iconCircle: css`
    width: 56px;
    height: 56px;
    border-radius: 50%;
    background: ${color.palette_status_red_tint_04};
    color: ${color.palette_status_red_100};
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    font-weight: ${typography.weight.bold};
    line-height: 1;
  `,
  text: css`
    margin: 0;
    color: ${color.text_default};
    font-size: ${typography.size.s2};
    line-height: 1.5;
  `,
  button: css`
    margin-top: ${spacing.common.small};
    min-width: 160px;
  `
};
